export default "__VITE_ASSET__BYykokDl__"